
import React from 'react';

const WholesalePriceSelector = ({
  selectedWholesalePrice,
  onWholesalePriceChange
}) => {
  const wholesalePrices = [
    { value: 'precio_mayorista_a', label: 'Mayorista A' },
    { value: 'precio_mayorista_b', label: 'Mayorista B' },
    { value: 'precio_mayorista_c', label: 'Mayorista C' }
  ];

  return (
    <div className="w-full flex justify-end mt-8 md:mt-10 relative z-0">
      <div className="flex gap-1 md:gap-2 bg-gray-100 rounded-full px-2 py-1 text-xs md:text-sm shadow-sm border border-gray-200">
        {wholesalePrices.map((price) => (
          <label
            key={price.value}
            className={`flex items-center px-2 py-1 rounded-full cursor-pointer transition-colors
              ${selectedWholesalePrice === price.value
                ? 'bg-blue-100 text-blue-700 border border-blue-200'
                : 'text-gray-500 hover:bg-gray-200'}
            `}
            style={{ fontWeight: selectedWholesalePrice === price.value ? 500 : 400 }}
          >
            <input
              type="radio"
              value={price.value}
              checked={selectedWholesalePrice === price.value}
              onChange={onWholesalePriceChange}
              className="accent-blue-400 mr-1"
              style={{ width: 14, height: 14 }}
            />
            {price.label}
          </label>
        ))}
      </div>
    </div>
  );
};

export default WholesalePriceSelector;
